import React from "react"
import AllCourses from "../Courses/allcourses";
import Footer from "../Footer/Footer";
import './style.css';

const LearnMore = () => {
  return (
    <>

<div className="container py-8 pt-lg-11" style={{background:"#36486b", paddingTop:"2.5rem"}}>
  <div className="row">
    <div className="col-xl-8 mx-auto">
      <h1 className="text-capitalize" style={{color:"#F79623", paddingTop:"2.5rem"}}>Seven Group Academy is the beacon of Africa.</h1>
      <p className="me-xl-12">Seven Group Academy is Known to provide quality IT Certification and Professions as well as certifications that can provide a competitive edge and open doors to 
       better job prospects and higher earning 
       potential.</p>
      <div className="d-md-flex align-items-center">
        <div className="border rounded-circle d-inline-block mb-4 mb-md-0 me-4">
          <div className="p-1">
            <img src={"assets/images/twitter-verified-badge.svg"} alt="..." className="rounded-circle" width="52" height="52" />
          </div>
        </div>
        <div className="mb-4 mb-md-0">
          <a href="#" className="d-block"><h6 className="mb-0" style={{fontWeight:"bold", color:"#33CC66"}}>Seven Group Academy</h6></a>
          <span className="font-size-sm">Trusted</span>
        </div>
      </div>
    </div>
  </div>
</div>

<div className="mb-8 sk-thumbnail img-ratio-7">
  <img src={"assets/images/bg10.jpg"} alt="..." className="img-fluid" />
</div>

<div className="container">
  <div className="row mb-8 mb-md-12">
    <div className="col-xl-8 mx-auto">
      <h3 className="" style={{color:"#F79623"}}>Taining Sessions</h3>
      <p className="mb-6 line-height-md"> We Provide Campus Training (Regular), Bootcamps and Online Training.</p>
      <h3 className="" style={{color:"#F79623"}}>Career Path</h3>
      <p className="mb-6 line-height-md">IT certifications can provide a competitive edge and open doors to better job prospects and higher earning potential.</p>
      <blockquote>
        <p>Our I.T Training with Internship, Training 
            with Job Placement, Training Only, or Job 
            Coaching are all approaches to
            enhancing I.T knowledge, skill set, and 
            career prospects.
        </p>
      </blockquote>
      <h3 className="mb-5" style={{color:"#F79623"}}>Job Title : System Administrator</h3>
      <div className="row row-cols-lg-2 mb-8">
        <div className="col-md">
          <ul className="list-style-v1 list-unstyled">
            <li>Cyber Security Specialist.</li>
            <li>Ethical Hacker.</li>
            <li>Computer Technician</li>
            <li>Computer Technician</li>
            <li>Cloud Architect</li>
          </ul>
        </div>
      </div>
      <h3 className="mb-5" style={{color:"#F79623"}}>Job Title : Software Developer</h3>
      <div className="row row-cols-lg-2 mb-8">
        <div className="col-md">
          <ul className="list-style-v1 list-unstyled">
            <li>Data Analyst / Scientist.</li>
            <li>Software Developer.</li>
            <li>Frontend Developer</li>
            <li>Backend Developer</li>
            <li>Mobile App Developer</li>
          </ul>
        </div>
        </div>
        <h3 className="mb-5" style={{color:"#F79623"}}>Job Title : Digital Designer</h3>
      <div className="row row-cols-lg-2 mb-8">
        <div className="col-md">
          <ul className="list-style-v1 list-unstyled">
            <li>UX/UI.</li>
            <li>Graphic Designer.</li>
            <li>Video Editor / Animator</li>
            <li>Art Director</li>
            <li> Product Designer</li>
          </ul>
        </div>
        </div>
        <h3 className="mb-5" style={{color:"#F79623"}}>Job Title : Digital Marketer</h3>
      <div className="row row-cols-lg-2 mb-8">
        <div className="col-md">
          <ul className="list-style-v1 list-unstyled">
            <li>Affiliate Marketer.</li>
            <li>Content Creator.</li>
            <li>Copy Writer</li>
            <li>Digital Marketer</li>
          </ul>
        </div>
        </div>
    </div>
  </div>
</div>
<AllCourses/>
<Footer/>


    
              
    </>
  )
}

export default LearnMore;
